import {Component, TemplateRef, contentChild, input, signal} from '@angular/core';

@Component({
  selector: 'app-tab',
  standalone: true,
  template: `<ng-content />`, // For eager loading fallback
  host: {
    '[style.display]': 'content() ? "none" : (isActive() ? "block" : "none")', // Hide entirely if using template
    '[class.tab-content]': '!content()',
    '[class.opacity-0]': '!isActive() && !content()',
    '[class.opacity-100]': 'isActive() && !content()',
    '[class.-translate-x-4]': '!isActive() && slideDirection() === "left" && !content()',
    '[class.translate-x-4]': '!isActive() && slideDirection() === "right" && !content()',
    '[class.translate-x-0]': 'isActive() && !content()',
    '[class.transition-all]': '!content()',
    '[class.duration-500]': '!content()',
    '[class.ease-in-out]': '!content()'
  }
})
export class Tab {
  title = input.required<string>()
  shortTitle = input<string>()
  disabled = input<boolean>(false)
  key = input<string|number|null>(null)
  id = input<string|number|null>(null);

  content = contentChild(TemplateRef);

  isActive = signal(false);
  hasBeenViewed = signal(false);
  slideDirection = signal<'left' | 'right'>('left');
}
